import gql from 'graphql-tag'
import { COURSE_FIELDS, USER_FIELDS } from './fragments'
import { PAGE_INFO_FIELDS } from '@/views/Project/gql/fragments'

export const COURSE_QUERY = gql`
    query getCourses($projectId: ID, $after: String) {
        courses(filter: { project: $projectId }, first: 25, after: $after) {
            nodes {
                ...CourseFields
            }
            pageInfo {
                ...PageInfoFields
            }
        }
    }
    ${COURSE_FIELDS}
    ${PAGE_INFO_FIELDS}
`

export const COURSE_COMPLETIONS_QUERY = gql`
    query getCourseCompletion($projectId: ID!, $course: ID, $users: [ID!], $after: String) {
        courseCompletions(
            filter: { project: $projectId, course: $course, users: $users }
            sort: { key: CREATED_AT, order: DESC }
            first: 15
            after: $after
        ) {
            nodes {
                canDelete
                completedAt
                createdAt
                expiresAt
                id
                updatedAt
                course {
                    ...CourseFields
                }
                ... on AttestedCourseCompletion {
                    attestingUser {
                        ...UserFields
                    }
                    forUser {
                        ...UserFields
                    }
                }
                ... on InstructedCourseCompletion {
                    version
                    attendees {
                        ...UserFields
                    }
                    instructor {
                        ...UserFields
                    }
                }
                ... on SelfAttestedCourseCompletion {
                    user {
                        ...UserFields
                    }
                }
                ... on SelfGuidedCourseCompletion {
                    version
                    user {
                        ...UserFields
                    }
                }
            }
            pageInfo {
                ...PageInfoFields
            }
        }
    }
    ${COURSE_FIELDS}
    ${USER_FIELDS}
    ${PAGE_INFO_FIELDS}
`
